/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getBloodPressureData = /* GraphQL */ `query GetBloodPressureData($date: String!, $device_id: String!) {
  getBloodPressureData(date: $date, device_id: $device_id) {
    date
    device_id
    diastolic
    heart_rate
    systolic
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBloodPressureDataQueryVariables,
  APITypes.GetBloodPressureDataQuery
>;
export const getESP32SensorData = /* GraphQL */ `query GetESP32SensorData($device_id: String!, $timestamp: String!) {
  getESP32SensorData(device_id: $device_id, timestamp: $timestamp) {
    device_id
    humidity
    pressure
    temperature
    spo2
    heart_rate
    timestamp
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetESP32SensorDataQueryVariables,
  APITypes.GetESP32SensorDataQuery
>;
export const listBloodPressureData = /* GraphQL */ `query ListBloodPressureData(
  $device_id: String!
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBloodPressureData(
    device_id: $device_id
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      date
      device_id
      diastolic
      heart_rate
      systolic
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBloodPressureDataQueryVariables,
  APITypes.ListBloodPressureDataQuery
>;
export const listESP32SensorData = /* GraphQL */ `query ListESP32SensorData(
  $device_id: String!
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listESP32SensorData(
    device_id: $device_id
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      device_id
      humidity
      pressure
      temperature
      spo2
      heart_rate
      timestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListESP32SensorDataQueryVariables,
  APITypes.ListESP32SensorDataQuery
>;
